<template>
  <div>
    <!-- Buscador -->
    <div v-if="!form.id">
      <b-form-group label="Buscar cliente">
        <div class="search-wrap">
          <span class="search-icon-left">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width size="sm" />
          </span>
          <b-input
            v-model="searchTerm"
            class="sc-search-input"
            placeholder="Buscar por nombre o código"
            autocomplete="off"
            autofocus
            :disabled="disableInput"
            @input="handleSearch"
            @focus="showCustomerDropdown = true"
            @blur="handleBlur"
            @keydown.enter="handleSearch"
          />
          <div v-if="showCustomerDropdown" class="search-dropdown">
            <div class="search-results">
              <template v-if="searching">
                <div class="search-no-result">
                  <b-spinner small type="grow"></b-spinner>
                  <span class="ml-1">Buscando...</span>
                </div>
              </template>
              <template v-else-if="results.length">
                <div
                  v-for="c in results"
                  :key="c.id"
                  class="search-opt"
                  @click="selectClient(c)"
                >
                  <span class="opt-code">{{ c.client_num }}</span>
                  <span class="opt-name">{{ c.name }}</span>
                  <span v-if="c.sap_frozen || !c.sap_valid" class="opt-invalid">
                    <span class="pl-1">Inactivo</span>
                  </span>
                </div>
              </template>
              <template v-else>
                <div class="search-no-result">
                  <font-awesome-icon :icon="['far', 'info-circle']" fixed-width  />
                  <span v-if="searchTerm && !results.length" class="ml-1">Sin resultados para "{{ searchTerm }}"</span>
                  <span v-if="!searchTerm" class="ml-1">Ingrese un término de búsqueda</span>
                </div>
              </template>
            </div>
            <div
              v-if="clientOptional"
              class="search-no-result-action"
              @click="setNoClient"
            >
              <span class="mr-1">Continuar sin cliente registrado</span>
              <font-awesome-icon :icon="['far', 'chevron-right']" fixed-width />
            </div>
          </div>
        </div>
      </b-form-group>
    </div>

    <!-- Cliente seleccionado -->
    <div v-else class="selected-card">
      <div class="selected-info">
        <div class="d-flex align-items-center">
          <span class="selected-meta">{{ form.client_num }}</span>
          <div v-if="form.sap_frozen" class="ml-2">
            <span class="mb-0 opt-invalid">Inactivo</span>
          </div>
        </div>
        <div class="selected-name">
          <span>{{ form.name }}</span>
        </div>
      </div>
      <button type="button" class="selected-clear" @click="clearClient" title="Volver a seleccionar cliente">
        <font-awesome-icon :icon="['far', 'times']" fixed-width size="lg"/>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientSearchV2',
  props: {
    clientOptional:{
      type: Boolean,
      default: false
    },
    clientSelected: {
      type: Object,
      default: () => {}
    },
    disableInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchTerm: '',
      showCustomerDropdown: false,
      searching: false,
      searchTimeout: null,
      form: {
        id: null,
        name: null,
        client_num: null,
        payment_terms: null
      },
      results: [],
    }
  },
  watch: {
    'clientSelected': {
      handler(clientByProp) {
        if (!clientByProp?.id) return
        this.form.id = clientByProp.id
        this.form.name = clientByProp.name
        this.form.client_num = clientByProp.client_num
        this.form.payment_terms = clientByProp.payment_terms
        this.form.sap_frozen = clientByProp.sap_frozen
        this.form.sap_valid = clientByProp.sap_valid
        this.searchTerm = ''
        this.showCustomerDropdown = false
      },
      deep: true
    }
  },
  methods: {
    handleBlur () {
      setTimeout(() => {
        this.showCustomerDropdown = false
      }, 150)
    },
    handleSearch () {
      clearTimeout(this.searchTimeout)

      if (!this.searchTerm.trim()) {
        this.results = []
        this.searching = false
        return
      }

      this.searching = true
      this.searchTimeout = setTimeout(() => this.searchClients(), 800)
    },
    searchClients () {
      this.$http.get('/api/production/clients/search', {
          params: { q: this.searchTerm }
        })
        .then(response => {
          // console.log(response)
          this.results = response.data || []
          this.searching = false
        })
        .catch(error => {
          // console.log(error)
          this.results = []
          this.searching = false
        })
    },
    selectClient (clientSelected) {
      this.form.id = clientSelected.id
      this.form.name = clientSelected.name
      this.form.client_num = clientSelected.client_num
      this.form.sap_frozen = clientSelected.sap_frozen
      this.form.sap_valid = clientSelected.sap_valid
      this.form.payment_terms = clientSelected.payment_terms

      this.$emit('select-client', this.form)

      this.searchTerm = ''
      this.showCustomerDropdown = false
    },
    clearClient () {
      this.$emit('reset-client')
      this.resetState()
    },
    setNoClient() {
      this.form.id = null
      this.form.name = null
      this.form.client_num = null
      this.form.payment_terms = null
      this.searchTerm = ''
      this.showCustomerDropdown = false

      this.$emit('set-no-client')
    },
    resetState () {
      this.form.id = null
      this.form.name = null
      this.form.client_num = null
      this.form.payment_terms = null

      this.searching = false
      this.results = []
      this.searchTerm = ''
      this.showCustomerDropdown = false
    }
  }
}
</script>

<style scoped>
  .search-wrap { position: relative; }
  .search-icon-left { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #aba9a9; pointer-events: none; display: flex; z-index: 1; }
  .sc-search-input { width: 100%; padding: 10px 14px 10px 36px; border: 1px solid #e0ddd6; border-radius: 8px; outline: none; transition: border-color 0.15s, box-shadow 0.15s; }
  .sc-search-input:focus { border-color: #1a1a1a; background: #fff; box-shadow: 0 0 0 3px rgba(26,26,26,0.07); }


  /* Selected card */
  .selected-card { display: flex; align-items: center; gap: 12px; background: #fafaf8; border: 1px solid #e5e3dc; border-radius: 9px; padding: 12px 14px; }
  .selected-info { flex: 1; }
  .selected-name { font-weight: 600; font-size: 1.1rem; color: #1a1a1a; line-height: 1rem; margin-top: 0.375rem;}
  .selected-meta { font-size: 1rem; color: #666464; margin-top: 1px; line-height: 10px; }
  .selected-clear { background: none; border: none; cursor: pointer; color: #ccc; padding: 5px; border-radius: 5px; line-height: 1; transition: color 0.15s, background 0.15s; }
  .selected-clear:hover { color: #e8380d; background: #fff0ee; }

  .search-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #e0ddd6;
    border-radius: 9px;
    z-index: 300;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12);
    display: flex;
    flex-direction: column;

    max-height: 200px;
    overflow: hidden;
  }
  .search-results {
    overflow-y: auto;
    flex: 1;
  }
  .search-opt { display: flex; align-items: center; gap: 10px; padding: 10px 14px; cursor: pointer; transition: background 0.1s; font-size: 0.84rem; }
  .search-opt:hover { background: #fafaf8; }
  .opt-code { font-size: 0.7rem; font-weight: 700; background: #f0ede6; color: #666; padding: 2px 8px; border-radius: 4px; white-space: nowrap; }
  .opt-invalid { font-size: 0.7rem; font-weight: 700; background: #d84b2e; color: #ffffff; padding: 2px 8px; border-radius: 4px; white-space: nowrap; }
  .opt-name { color: #1a1a1a; font-weight: 500; flex: 1; }
  .opt-meta { font-size: 0.7rem; color: #aaa; }
  .search-no-result { display: flex; align-items: center; justify-content: center; padding: 14px 16px; font-size: 0.8rem; color: #aaa; }
  .search-no-result-action { display: flex; align-items: center; justify-content: center; padding: 11px 16px; font-size: 0.82rem; color: #e8380d; font-weight: 600; cursor: pointer; border-top: 1px solid #f5f3ef; transition: background 0.1s; }
  .search-no-result-action:hover { background: #fff8f6; }
</style>